import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Grid2,
  Typography,
  MenuItem,
  Box,
  Paper,
  Select,
  Chip,
  Card,
  Snackbar,
  Alert,
  Autocomplete,
  TextField,
  Tooltip,
  Avatar
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getContentTypes } from "../../actions/contentActions";

import { useDispatch, useSelector } from "react-redux";
import { usePermission } from "../authentication/permission-providor/UserPermission";

//Abdllah
import { Link, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import EditIcon from "../../components/icons/EditIcon";

import { getAllEntries, removeEntry } from "../../actions/entryActions";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "../../components/icons/RemoveIcon";
import AddButton from "../../themes/overrides/AddButton";
import CopyIcon from "../../components/icons/CopyIcon"
import ContentPopup from "./ContentPopup";
import SearchField from "../../themes/overrides/SearchField";
import { DataGrid } from "@mui/x-data-grid";

import DefaulImg from "../../assets/images/grayRectangle.png";
import DefaulImg2 from "../../assets/images/rec_image.png";

import DropDownMenu from "../../themes/overrides/DropDownMenu";
import BrushIcon from "../../assets/images/brush.svg";

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloudDoneOutlinedIcon from "@mui/icons-material/CloudDoneOutlined";
import CloudOffOutlinedIcon from "@mui/icons-material/CloudOffOutlined";
import CustomCardMedia from "../../themes/overrides/CustomCardMedia";
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LoadingOverlay from "../../components/LoadingOverlay";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import ListIcon from "../../components/icons/ListIcon";
import GridIcon from "../../components/icons/GridIcon";
import TextFieldInput from '../../themes/overrides/TextFieldInput';
import { useParams } from 'react-router-dom';
import { SkeletonRowsOverlay } from "../../components/SkeletonRowsOverlay";

const AllContents = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const contentTypes = useSelector((state) => state.form.contentTypes);
  const [loading, setLoading] = useState(() => {
    return !contentTypes || contentTypes.length === 0;
  });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
  });
  const [totalEntries, setTotalEntries] = useState(0);
  const [searchLoading, setSearchLoading] = useState(true);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedContentToDelete, setSelectedContentToDelete] = useState(null);

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const { hasPermission } = usePermission();


  // const [gridColor, setGridColor] = useState("#6B6B6B");
  // const [listColor, setListColor] = useState("#6B6B6B");
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedContentType, setSelectedContentType] = useState("");
  // const theme = useTheme();

  const { workspaceId } = useParams();
  const data = useSelector((state) => state.entry.entries);

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const searchTimeoutRef = useRef(null);


  const [cachedPages, setCachedPages] = useState({});
  const currentPageData = cachedPages[paginationModel.page] || [];
  const [isSearching, setIsSearching] = useState(false);
  const [rowsLoading, setRowsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(() => {
    const storedValue = sessionStorage.getItem(`contentSearchTerm_${workspaceId}`);
    return storedValue || '';
  });

  const [viewMode, setViewMode] = useState(() => {
    const storedValue = sessionStorage.getItem(`contentViewMode_${workspaceId}`);
    return storedValue || 'list';
  });

  const [sortField, setSortField] = useState(() => {
    const storedValue = sessionStorage.getItem(`sortField_${workspaceId}`);
    return storedValue || null;
  });

  const [sortOrder, setSortOrder] = useState(() => {
    const storedValue = sessionStorage.getItem(`sortOrder_${workspaceId}`);
    return storedValue || "asc";
  });

  const [selectedFilterdValue, setSelectedFilteredValue] = useState(() => {
    const storedValue = sessionStorage.getItem(`selectedFilterdValue_${workspaceId}`);
    return storedValue ? JSON.parse(storedValue) : null;
  });
  const currentWorkspace = useSelector((state) => state.workspace.workspaceInfo);
  const [hasRestoredFromSession, setHasRestoredFromSession] = useState(false); // Search term from session

  // function getMediaFieldIds(contentModelId) {
  //   // Find the content model with the specified _id
  //   const contentModel = contentTypes.find(model => model._id === contentModelId);

  //   if (!contentModel) {
  //     return `Content model with _id ${contentModelId} not found.`;
  //   }

  //   // Filter fields of type 'media' and return their ids
  //   const mediaFieldIds = contentModel.fields
  //     .filter(field => field.type === "media")
  //     .map(field => field.id);

  //   return mediaFieldIds;
  // }

  // const handleToggleView = (view) => {
  //   if (view === "List") {
  //     setViewMode("list");
  //     setListColor("#006D70");
  //     setGridColor("#6B6B6B");
  //   } else {
  //     setViewMode("grid");
  //     setGridColor("#006D70");
  //     setListColor("#6B6B6B");
  //   }
  // };

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleCloseMenu = () => {
  //   setAnchorEl(null);
  // };

  // const handleSelectContentType = (contentType, id) => {
  //   setSelectedContentType(contentType);
  //   console.log(id);
  //   //load the content fields

  //   setIsModalOpen(true); // Open modal
  //   handleCloseMenu();
  // };

  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  //   setSelectedContentType(""); // Reset selected content type
  // };

  useEffect(() => {
    if (workspaceId) {
      setLoading(true);
      dispatch(getContentTypes(workspaceId))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [workspaceId, dispatch]);

  const loadPageData = async (page, isPrefetch = false, force = false) => {
    if (!isPrefetch && cachedPages[page] && !force) return; // IF already cached return

    // Skip if we have 1-2 characters in search term
    if (debouncedSearchTerm.length > 0 && debouncedSearchTerm.length < 3) {
      return;
    }

    try {
      if (!isPrefetch) setSearchLoading(true);

      const params = {
        page: page + 1,
        ...(debouncedSearchTerm.length >= 3 && { identifier: debouncedSearchTerm }),
        ...(selectedFilterdValue && { contentTypeId: selectedFilterdValue._id })
      };

      const result = await dispatch(getAllEntries(workspaceId, params));

      if (!isPrefetch) {
        setTotalEntries(result.totalEntries || 0);
      }

      setCachedPages(prev => ({
        ...prev,
        [page]: result.entries || []
      }));

      if (!isPrefetch && (result.entries?.length === 30)) {
        loadPageData(page + 1, true);
      }
    } catch (error) {
      if (!isPrefetch) {
        setSnackbar({ open: true, message: "Failed to load entries", severity: "error" });
      }
    } finally {
      if (!isPrefetch) {
        setSearchLoading(false);
        setRowsLoading(false); // Reset loading when data is loaded
      }
    }
  };

  // Check if there is any search or filter terms from session, if there is set search or filter term
  useEffect(() => {
    if (workspaceId && !hasRestoredFromSession) {
      const savedSearchTerm = sessionStorage.getItem(`contentSearchTerm_${workspaceId}`) || "";
      const savedFilterValue = sessionStorage.getItem(`selectedFilterdValue_${workspaceId}`);

      setSearchTerm(savedSearchTerm);
      setDebouncedSearchTerm(savedSearchTerm);
      setIsSearching(savedSearchTerm.length > 0);

      if (savedFilterValue) {
        try {
          setSelectedFilteredValue(JSON.parse(savedFilterValue));
        } catch (e) {
          console.error("Failed to parse saved filter", e);
        }
      }

      setPaginationModel({ page: 0 });
      setRowsLoading(true);
      setCachedPages({});
      // loadPageData(0); // Removed redundant call
      setHasRestoredFromSession(true); // Used so that UseEffect below wont run causing multiple useEffect calls
    }
  }, [workspaceId]);

  // Used for fresh search calls
  useEffect(() => {
    if (workspaceId && hasRestoredFromSession) {
      loadPageData(paginationModel.page);
    }
  }, [workspaceId, paginationModel.page, debouncedSearchTerm, selectedFilterdValue, isSearching, hasRestoredFromSession, cachedPages]);


  // Cleanup for the timeout
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const handlePageChange = (newPage) => {
    // Skip if page is already cached
    // if (!cachedPages[newPage]) {
    //   loadPageData(newPage);
    // }

    setPaginationModel({ page: newPage });

    // Prefetch next page only if current one has exactly 30 and next isn’t cached
    if (
      cachedPages[newPage]?.length === 30 &&
      cachedPages[newPage + 1] === undefined
    ) {
      loadPageData(newPage + 1, true);
    }
  };


  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setIsSearching(value.length > 0);
    // Clear any pending debounce
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    if (value.length === 0) {
      // If clearing the search completely, run immediately
      setDebouncedSearchTerm(""); // Clears identifier
      setCachedPages({});
      setPaginationModel({ page: 0 });
      setRowsLoading(true);
      // loadPageData(0); // force reload first page
    } else if (value.length >= 3) {
      // Valid search: debounce the fetch
      setRowsLoading(true);
      searchTimeoutRef.current = setTimeout(() => {
        setDebouncedSearchTerm(value);
        setCachedPages({});
        setPaginationModel({ page: 0 });
      }, 500);
    } else {
      // Invalid short search: reset
      setDebouncedSearchTerm("");
      setRowsLoading(false);
    }
  };



  const handleFilterChange = (event, newValue) => {
    setSelectedFilteredValue(newValue);
    setIsSearching(true);
    setRowsLoading(true); // Add loading state
    // Reset cache and pagination
    setCachedPages({});
    setPaginationModel({ page: 0 });
  };


  // Save to sessionStorage whenever state changes
  useEffect(() => {
    sessionStorage.setItem(`contentSearchTerm_${workspaceId}`, searchTerm);
  }, [searchTerm, workspaceId]);

  useEffect(() => {
    sessionStorage.setItem(`contentViewMode_${workspaceId}`, viewMode);
  }, [viewMode, workspaceId]);

  useEffect(() => {
    sessionStorage.setItem(`sortField_${workspaceId}`, sortField);
  }, [sortField, workspaceId]);

  useEffect(() => {
    sessionStorage.setItem(`sortOrder_${workspaceId}`, sortOrder);
  }, [sortOrder, workspaceId]);

  useEffect(() => {
    if (selectedFilterdValue) {
      sessionStorage.setItem(`selectedFilterdValue_${workspaceId}`, JSON.stringify(selectedFilterdValue));
    } else {
      sessionStorage.removeItem(`selectedFilterdValue_${workspaceId}`);
    }
  }, [selectedFilterdValue, workspaceId]);

  const navigateCreateEntryPage = (workspaceId, id) => {
    navigate(`/${workspaceId}/create-entry/${id}`);
  };

  const navigateEditEntryPage = (workspaceId, params) => {
    navigate(`/${workspaceId}/edit-entry/${params.row._id}`);
  };



  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const columns = [
    // {
    //   field: "image",
    //   headerName: "Image",
    //   renderCell: (params) => (
    //     <Card
    //       sx={{
    //         padding: 1,
    //         justifyContent: "center",
    //         margin: "2px auto",
    //         display: "block",
    //         alignItems: "center",
    //       }}
    //     >
    //       <CustomCardMedia
    //         component="img"
    //         image={params?.row?.data?.[getMediaFieldIds(params?.row?.contentTypeId)?.[0]]?.[0]?.url ?? DefaulImg}
    //         alt="image"
    //       ></CustomCardMedia>
    //     </Card>
    //   ),
    // },
    // { field: "id", headerName: "ID",flex:1 },
    { field: "identifier", headerName: "Identifier", flex: 1, sortable: false },
    { field: "content_type_name", headerName: "Content type", flex: 1, sortable: false },
    {
      field: "published",
      headerName: "Status",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Box>
          {params.row.published ? (
            <Chip
              icon={<CloudDoneOutlinedIcon />}
              label="Published"
              size="small"
              color="#D4F5F5"
              style={{ backgroundColor: "#D4F5F5" }}
            />
          ) : (
            <Chip
              icon={<CloudOffOutlinedIcon />}
              label="Draft"
              size="small"
              color="#F0F0F0"
            />
          )}
        </Box>
      ),
    },
    {
      field: "updatedAt", headerName: "Updated At", flex: 1, sortable: false,
      renderCell: (params) => {
        const utcString = params.row.updatedAt || params.row.createdAt;

        // Convert UTC string to local time
        const localTime = new Date(utcString).toLocaleString();

        return (
          <Box>
            {localTime}
          </Box>
        );
      },
    },
    {
      field: "updated_by",
      headerName: "Updated By",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        // Get user_details from currentWorkspace
        const userDetails = currentWorkspace.data?.user_details || [];

        // Helper function to find user by email or ID and return avatar
        const getUserWithAvatar = (identifier, isEmail = true) => {
          const user = userDetails.find(u =>
            isEmail ? u.email === identifier : u._id === identifier
          );
          if (!user) return null;

          return (
            <Box display="flex" alignItems="center" gap={1}>
              <Avatar
                src={user.avatarUrl}
                alt={user.name}
                sx={{ width: 24, height: 24 }}
              />
              <span>{user.name}</span>
            </Box>
          );
        };

        // Check versionData (last user)
        const lastVersionUser = params.row.versionData
          ? Object.values(params.row.versionData).pop()?.user
          : null;
        const versionUserDisplay = lastVersionUser
          ? getUserWithAvatar(lastVersionUser, true)
          : null;

        // Fallback to createdBy (user ID)
        const createdById = params.row.createdBy;
        const createdByDisplay = createdById
          ? getUserWithAvatar(createdById, false)
          : null;

        return versionUserDisplay || createdByDisplay || <Box>Unknown</Box>;
      }
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton
            color="secondary"
            onClick={() => navigateEditEntryPage(workspaceId, params)}
            aria-label="edit"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleDelete(params.row._id)}
            aria-label="delete"
            disabled={!hasPermission('admin')}
          >
            <RemoveIcon />
          </IconButton>
          <Tooltip title="Copy Content ID" arrow>
            <IconButton
              color="secondary"
              onClick={() => handleCopy(params.row._id)}
              aria-label="copy"
            >
              <CopyIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  // const filteredRows = useMemo(() => {
  //   if (!Array.isArray(currentPageData)) return [];

  //   // Apply sorting if needed
  //   const sorted = sortField
  //     ? [...currentPageData].sort((a, b) => {
  //       if (!a[sortField]) return sortOrder === "asc" ? -1 : 1;
  //       if (!b[sortField]) return sortOrder === "asc" ? 1 : -1;
  //       return sortOrder === "asc"
  //         ? a[sortField].localeCompare(b[sortField])
  //         : b[sortField].localeCompare(a[sortField]);
  //     })
  //     : currentPageData;

  //   return sorted.map((row, index) => ({
  //     id: row._id,
  //     ...row,
  //   }));
  // }, [currentPageData, sortField, sortOrder]);

  const filteredRows = useMemo(() => {
    if (!Array.isArray(currentPageData)) return [];

    // Just map the rows as-is, without sorting
    return currentPageData.map((row) => ({
      id: row._id,
      ...row,
    }));
  }, [currentPageData]);


  const handleSortChange = (event) => {
    const value = event.target.value;
    if (value === "Sort by") {
      setSortField(null);
    } else if (value === "Identifier") {
      setSortField("identifier");
      setSortOrder("asc"); // Default to ascending order
    } else if (value === "Content Type") {
      setSortField("content_type_name");
      setSortOrder("asc"); // Default to ascending order
    } else if (value === "Updated At") {
      setSortField("updated_at");
      setSortOrder("asc"); // Default to ascending order
    } else if (value === "Updated By") {
      setSortField("updated_by");
      setSortOrder("asc"); // Default to ascending order
    }
  };


  const handleEdit = (id) => {
    navigate(`/${workspaceId}/edit-entry/${id}`);
  };

  const handleDelete = (id) => {
    setSelectedContentToDelete(id);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // Dispatch the delete action first
      await dispatch(removeEntry(selectedContentToDelete));

      // Then clear the cache and reload
      setCachedPages({});
      setPaginationModel(prev => ({ ...prev, page: 0 })); // Reset to first page
      setRowsLoading(true);

      setSnackbar({ open: true, message: "Entry deleted successfully!", severity: "success" });
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to delete entry.", severity: "error" });
    } finally {
      setDeleteModalOpen(false);
      setSelectedContentToDelete(null);
    }
  };

  const handleCopy = async (id) => {
    try {
      const textToCopy = id;
      await navigator.clipboard.writeText(textToCopy);
      setSnackbar({ open: true, message: "Content copied to clipboard!", severity: "success" });

    } catch (err) {
      setSnackbar({ open: true, message: "Failed to copy", severity: "error" })

    }
  }


  const [contentTypeSearch, setContentTypeSearch] = useState("");

  return (
    loading ? <LoadingOverlay /> :
      <Grid2 container spacing={2}>
        <Grid2 size={12} justifyContent="space-between"
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
          }}
        >
          <Grid2 size={{ xs: 12, md: 6 }} display="flex" alignItems="center" sx={{ marginLeft: { xs: 4, md: 0 } }}>
            <Box component="img" sx={{ width: { xs: 32, md: 40 }, marginRight: { xs: 2, md: 4 } }} src={BrushIcon} />
            <Typography variant="h1">All Contents</Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 4 }} sx={{ marginTop: { xs: 1, md: 0 } }} display="flex" justifyContent="flex-end">
            <PopupState variant="popover" popupId="demo-popup-menu">
              {(popupState) => (
                <>
                  <AddButton
                    label="Add Entry"
                    variant="contained"
                    {...bindTrigger(popupState)}
                    disabled={!hasPermission('editor')}
                  />
                  <DropDownMenu
                    {...bindMenu(popupState)}
                    PaperProps={{
                      style: {
                        maxHeight: 300,
                        minWidth: 200
                      }
                    }}
                  >
                    <Box sx={{ p: 1, position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Search..."
                        fullWidth
                        variant="outlined"
                        value={contentTypeSearch}
                        onChange={(e) => setContentTypeSearch(e.target.value)}
                        onKeyDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Box>
                    {contentTypes
                      .filter(contentType =>
                        contentType.fields &&
                        contentType.fields.length > 0 &&
                        contentType.name.toLowerCase().includes(contentTypeSearch.toLowerCase())
                      )
                      .map((contentType) => (
                        <MenuItem
                          key={contentType._id}
                          onClick={() => {
                            navigateCreateEntryPage(
                              contentType.workspaceId,
                              contentType._id
                            );
                            setContentTypeSearch(""); // Clear search on selection
                            popupState.close();
                          }}
                        >
                          {contentType.name}
                        </MenuItem>
                      ))}
                    {contentTypes.filter(contentType =>
                      contentType.fields &&
                      contentType.fields.length > 0 &&
                      contentType.name.toLowerCase().includes(contentTypeSearch.toLowerCase())
                    ).length === 0 && (
                        <MenuItem disabled>No types found</MenuItem>
                      )}
                  </DropDownMenu>
                </>
              )}
            </PopupState>
          </Grid2>
        </Grid2>

        <Grid2 size={12} container >
          <Grid2 size={12}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: {
                  xs: 'column',
                  md: 'row',
                },
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                pt: 2,
                borderRadius: 2,
              }}
            >
              <SearchField
                placeholder="Search Content"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearch}
                sx={{
                  mb: {
                    xs: 1,
                    md: 0
                  }
                }}
              />
              <Autocomplete
                sx={{
                  flex: 1,
                }}
                options={contentTypes}
                getOptionLabel={(option) => option.name}
                value={selectedFilterdValue}
                onChange={handleFilterChange}
                noOptionsText="No content type found"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Filter by Content Type"
                    fullWidth
                    sx={{ minWidth: 225 }}
                    placeholder="Type to search..."
                  />
                )}
              />

              {/* <Box display="flex" justifyContent="space-between" sx={{ gap: 2 }} > */}
              {/* <Box sx={{ border: '1px solid #6B6B6B', borderRadius: 2, background: 'white' }}>
                  <IconButton onClick={() => handleToggleView("List")}>
                    <ListIcon toggleColor={listColor} />
                  </IconButton>
                  <IconButton onClick={() => handleToggleView("Grid")}>
                    <GridIcon toggleColor={gridColor} />
                  </IconButton>
                </Box> */}


              {/* <Select
                  size="small"
                  defaultValue="Sort by"
                  sx={{ minWidth: 200, color: '#6B6B6B', borderRadius: 2, border: '1px solid #6B6B6B', background: 'white' }}
                  onChange={handleSortChange}
                >
                  <MenuItem value="Sort by">Sort by</MenuItem>
                  <MenuItem value="Identifier">Identifier</MenuItem>
                  <MenuItem value="Content Type">Content Type</MenuItem>
                </Select> */}
              {/* </Box> */}
            </Box>
          </Grid2>

          <Grid2 size={12} sx={{ overflowX: 'auto' }}>
            <Paper elevation={2} sx={{ padding: 2, marginBottom: 2, marginTop: { md: 2 }, overflowX: 'auto' }}>
              {rowsLoading ? (
                <SkeletonRowsOverlay
                  columnsCount={columns.length}
                  rowsCount={8}
                />
              ) : filteredRows.length > 0 ? (
                viewMode === "list" ? (
                  <Box
                    sx={{
                      width: '100%',
                      overflowX: 'auto',
                    }}
                  >
                    <DataGrid
                      getRowId={(row) => row._id}
                      rows={filteredRows || []}
                      columns={columns}
                      rowCount={totalEntries}
                      loading={searchLoading || rowsLoading}
                      paginationMode="server"
                      paginationModel={paginationModel}
                      onPaginationModelChange={setPaginationModel}
                      pageSizeOptions={[]}
                      pageSize={30}
                      disableColumnSelector
                      disableRowSelectionOnClick
                      disableColumnMenu
                      sx={{
                        minWidth: 600,
                        '& .MuiDataGrid-cell:focus': {
                          outline: 'none'
                        },
                        '& .MuiTablePagination-displayedRows': {
                          display: 'none' // Hide the default label
                        },
                        '& .MuiTablePagination-actions': {
                          display: 'none' // Hide default pagination buttons
                        }
                      }}
                      slots={{
                        pagination: () => (
                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            width: '100%',
                            gap: 2,
                            padding: '0 16px'
                          }}>
                            <Typography variant="body2">
                              {filteredRows.length} Entries
                            </Typography>

                            <IconButton
                              onClick={() => handlePageChange(paginationModel.page - 1)}
                              disabled={paginationModel.page === 0}
                              size="small"
                            >
                              <ChevronLeftIcon />
                            </IconButton>

                            <Typography variant="body2">
                              Page {paginationModel.page + 1}
                            </Typography>

                            <IconButton
                              onClick={() => handlePageChange(paginationModel.page + 1)}
                              disabled={
                                !cachedPages[paginationModel.page + 1] ||  // Next page not cached
                                cachedPages[paginationModel.page + 1]?.length === 0 ||  // Next page cached but empty
                                searchLoading  // Still loading
                              }

                              size="small"
                            >
                              <ChevronRightIcon />
                            </IconButton>

                          </Box>
                        ),
                        loadingOverlay: () => <SkeletonRowsOverlay columnsCount={columns.length} rowsCount={8} />,
                      }}
                    />
                  </Box>
                ) : (
                  <Grid2 container spacing={2} sx={{ flexWrap: 'wrap' }}>
                    {filteredRows.map((data, i) => (
                      <Grid2 key={i} size={{ xs: 12, md: 3 }}>
                        {/* Content Card */}
                        <Box sx={{ border: "1px solid #ddd", borderRadius: 2 }}>
                          {/* <Box
                            component="img"
                            sx={{
                              width: '100%',
                              height: 'auto',
                            }}
                            src={data.data?.[getMediaFieldIds(data?.contentTypeId)?.[0]]?.[0]?.url ?? DefaulImg}
                            alt="Cancel Icon"
                          /> */}
                          {/* <img
                             
                              style={{ width: '100%' }}
                            /> */}
                          {/* </Box> */}
                          <Box p={2}>
                            <Typography variant="body1">
                              {data.identifier}
                            </Typography>
                          </Box>
                          <Box paddingLeft={2}>
                            <Chip icon={<LocalOfferOutlinedIcon />} label={data.content_type_name} size="small" />
                          </Box>
                          <Box paddingLeft={2}>
                            <Chip
                              icon={data.published ? <CloudDoneOutlinedIcon /> : <CloudOffOutlinedIcon />}
                              label={data.published ? "Published" : "Draft"}
                              size="small"
                              color={data.published ? "D4F5F5" : "#D4F5F5"}
                            />
                          </Box >

                          <Box paddingLeft={2} display="flex">
                            <IconButton
                              color="secondary"
                              onClick={() => handleEdit(data._id)}
                              aria-label="edit"
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="secondary"
                              onClick={() => handleDelete(data._id)}
                              aria-label="delete"
                              disabled={!hasPermission('admin')}
                            >
                              <RemoveIcon />
                            </IconButton>
                            <IconButton
                              color="secondary"
                              onClick={() => handleCopy(data._id)}
                              aria-label="copy"
                            >
                              <CopyIcon />
                            </IconButton>
                          </Box>
                        </Box>
                      </Grid2>
                    ))
                    }
                  </Grid2>
                )) : (
                <Typography align="center">No Contents</Typography>
              )}
            </Paper>
          </Grid2>
        </Grid2>

        <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}
            variant="filled">
            {snackbar.message}
          </Alert>
        </Snackbar>

        <DeleteConfirmationModal

          open={deleteModalOpen}
          onClose={() => {
            setDeleteModalOpen(false);
            setSelectedContentToDelete(null);
          }}
          text="Are you sure you want to delete this content? Deleting it will also remove it from any referenced fields."
          onConfirm={handleConfirmDelete}
          deleteButtonLabel="Delete"
        />
      </Grid2 >
  );
};

export default AllContents;
